var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"py-6 d-flex flex-row justify-start",on:{"click":_vm.connectToFacebook}},[_c('v-img',{staticClass:"mr-2 flex-grow-0",attrs:{"src":_vm.KindTypeIcon.facebookPost,"width":"30","height":"30"}}),_vm._v(" "+_vm._s(_vm.$t('buttons.social-media.connect-facebook'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }